import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AccordionContent',
  props: {
    transition: { default: undefined },
    contentClass: { default: '' },
    expanded: { type: Boolean },
    backgroundColor: { default: undefined },
    prerenderContent: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { transition: string | undefined, contentClass: string, expanded?: boolean, backgroundColor: string, prerenderContent?: boolean }



const content = ref(null);

function beforeEnter(el: HTMLDivElement) {
    if (props.transition) { return; }
    el.style.maxHeight = '0';
}

function enter(el: HTMLDivElement) {
    if (props.transition) { return; }
    el.style.maxHeight = el.scrollHeight + 'px';
}

function afterEnter(el: HTMLDivElement) {
    if (props.transition) { return; }
    el.style.maxHeight = 'unset';
}

function beforeLeave(el: HTMLDivElement) {
    if (props.transition) { return; }
    el.style.maxHeight = el.scrollHeight + 'px';
}

function leave(el: HTMLDivElement) {
    if (props.transition) { return; }

    // Set max height to actual height to allow transition to work (transition from "unset" to "0" is abrupt)
    el.style.maxHeight = el.scrollHeight + 'px';
    el.style.maxHeight = '0';
}

return { __sfc: true,props, content, beforeEnter, enter, afterEnter, beforeLeave, leave }
}

})